module.exports = __webpack_public_path__ + "static/media/delta.96f3e7ea.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/delta.png
// module id = 313
// module chunks = 0